<template>
  <div>
    <van-nav-bar left-arrow left-text="返回" title="拼箱合并" @click-left="onClickLeft">
      <template #right>
        <van-icon name="cart" size="30" @click="goIndex()" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field ref="sBarcode" v-model="sBarcode" autofocus label="原拼箱条码" left-icon="photograph" @keyup="onsBarcode" />
    </van-cell-group>
    <van-cell-group>
      <van-field ref="tBarcode" v-model="tBarcode" label="目的拼箱条码" left-icon="photograph" @keyup="ontBarcode" />
    </van-cell-group>
    <van-cell-group>
      <van-field ref="sGroupage" v-model="sGroupage" label="原拼箱号" left-icon="photograph" readonly />
    </van-cell-group>
    <van-cell-group>
      <van-field ref="tGroupage" v-model="tGroupage" label="目的拼箱号" left-icon="photograph" readonly />
    </van-cell-group>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="0">
            <van-button block native-type="clean" round style="margin: 10px;" type="info" @click="clean">清空</van-button>
          </van-col>
          <van-col span="0">
            <van-button block native-type="merge" round style="margin: 10px;" type="info" @click="merge">并包</van-button>
          </van-col>
          <van-col span="0">
            <van-button block native-type="Sprint" round style="margin: 10px;" type="info" @click="Sprint">标签补打</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  import debounce from 'lodash/debounce'
  import { findOne, post } from '@/api/Api'
  import { Toast } from 'vant'
  import api from '@/api'

  export default {
    components: {},
    data() {
      return {
        sBarcode: '',
        sGroupage: '',
        tBarcode: '',
        tGroupage: '',
        result: {}
      }
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onsBarcode: debounce(function(data) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.scan(value, 1)
        }
      }, 300),
      ontBarcode: debounce(function(data) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.scan(value, 2)
        }
      }, 300),
      scan(value, index) {
        let args = {
          no: value
        }
        findOne('shipmentBarcodeFactory', args).then(res => {
          if (index === 1) {
            this.sGroupage = res.result.groupage
          } else {
            this.tGroupage = res.result.groupage
          }
        })
      },
      clean() {
        this.sBarcode = null
        this.tBarcode = null
        this.sGroupage = null
        this.tGroupage = null
      },
      merge() {
        if (!this.sBarcode || !this.tBarcode) {
          Toast('请扫描原条码和目的条码！')
          return
        }
        let args = {
          'source': this.sBarcode,
          'target': this.tBarcode
        }
        post(api.reviewMerge, {}, args).then(res => {
          if (res.success) {
            Toast('并包成功！')
            this.clean()
          }
        })
      },
      Sprint() {
      }
    }
  }
</script>